export default "__VITE_ASSET__DEurEIZQ__"